export default __webpack_public_path__ + "static/media/email.4fd094ef.svg";